import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AddPendingCompanyToProjectPayload } from '@/api/v4/projects.api';
import { addPendingCompanyToProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { projectIdState } from '../project.state';
import { getAtomValue } from '@/shared/jotai';

export const useAddPendingCompanyToProject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      pendingCompanyId,
    }: {
      pendingCompanyId: string;
      payload?: AddPendingCompanyToProjectPayload;
    }) => {
      const projectId = getAtomValue(projectIdState);
      if (!projectId) throw new Error('Project ID is required');

      return addPendingCompanyToProject(projectId, pendingCompanyId);
    },
    onSuccess: async () => {
      const projectId = getAtomValue(projectIdState);
      if (!projectId) return;

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.PendingCompanies, projectId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.PendingCompaniesCount, projectId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectListings, projectId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectListingsCount, projectId],
        }),
      ]);
    },
  });
};
